type BudgyMarkProps = {
  className?: string;
};

export const BudgyMark = ({ className }: BudgyMarkProps) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height="28"
    viewBox="0 0 24 24"
    width="28"
  >
    <path
      d="M9.6 9.6 C6.6 11.6 6 15.8 8.6 19.4 H14.6 C17.6 16.8 18.2 13.2 17.2 10.6 Z"
      fill="#48D75B"
      stroke="#0E0E0C"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M10.4 12.6 C12.4 13.6 12.9 16 12.1 18.2"
      stroke="#0E0E0C"
      strokeLinecap="round"
      strokeWidth="1.3"
    />
    <circle
      cx="13.6"
      cy="7.6"
      fill="#FFFFFF"
      r="4.2"
      stroke="#0E0E0C"
      strokeWidth="1.5"
    />
    <circle cx="14.8" cy="7.2" fill="#0E0E0C" r="0.95" />
    <path
      d="M17.5 7.3 C19.4 7.4 20.2 9 19 10.6 L17.4 9.4 Z"
      fill="#0E0E0C"
      stroke="#0E0E0C"
      strokeLinejoin="round"
      strokeWidth="0.8"
    />
    <path
      d="M9.4 19.4 L7.4 22.6 M11.2 19.4 V21.6 M13.4 19.4 V21.6"
      stroke="#0E0E0C"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
  </svg>
);

const BudgyWordmark = () => (
  <>
    <BudgyMark />
    <span className="text-[19px] font-semibold tracking-[-0.02em]">Budgy</span>
  </>
);

export default BudgyWordmark;
